import { Metadata } from "next";
import { OpenGraph } from "next/dist/lib/metadata/types/opengraph-types";
import { Twitter } from "next/dist/lib/metadata/types/twitter-types";

export const AD_DETAILS_BODY_WIDTH_NUMBER = 800;
export const AD_DETAILS_BODY_WIDTH = AD_DETAILS_BODY_WIDTH_NUMBER + "px";
export const AD_DETAILS_ASIDE_WIDTH = "550px";
export const AD_DETAILS_2_COLUMN_MAX_WIDTH = 1300;
export const BOX_SHADOW_SIZE_MEDIUM = 4;
export const BOX_SHADOW_SIZE_LARGE = 12;
export const BRAND_COLOR = "#cf2424";
export const PRIMARY_COLOR = "#279e4e";
export const PRIMARY_COLOR_RGB = "39,158,78";
export const RV_OTT_BLUE_RGB = "0,109,166";
export const RV_OTT_PINK_RGB = "237,0,140";
export const RV_OTT_GRADIENT = `linear-gradient(45deg, rgb(${RV_OTT_BLUE_RGB}) 0%, rgb(${RV_OTT_PINK_RGB}) 100%)`;
export const FEATURED_COLOR = "#0e539e";
export const NAV_SELECTED_BACKGROUND_COLOR = "grey.200";
export const FOOTER_GREY = "300";
export const PAGE_GUTTER_DESKTOP = 20;
export const PAGE_GUTTER_TABLET = 10;
export const PAGE_GUTTER_MOBILE = 2;
export const AD_DETAILS_BORDER_RADIUS = 6;
export const HIDE_SCROLLBAR_STYLE = {
  "&::-webkit-scrollbar": {
    display: "none",
  },
  scrollbarWidth: "none",
  msOverflowStyle: "none",
};
export const META_BRAND_NAME = "Horsezone.com.au";
export const META_AUSTRALIAS_NUMBER_1 =
  "Australia's #1 Equine Marketplace";
export const WEB_URL_BASE = "https://horsezone.com.au";

export const META_DESCRIPTION =
  "Buy & sell horses and everything equestrian related in Australia & New Zealand. Free to list horses, floats & trucks under $5,000 until sold.";

export const META_LOCALE = "en-AU";

const TITLE_AND_DESCRIPTION = {
  title: `${META_BRAND_NAME} - ${META_AUSTRALIAS_NUMBER_1} since 2010`,
  description: META_DESCRIPTION,
};

export const META_OG_BASE: OpenGraph = {
  ...TITLE_AND_DESCRIPTION,
  type: "website",
  url: WEB_URL_BASE + "/",
  siteName: META_BRAND_NAME,
  locale: META_LOCALE,
  images: WEB_URL_BASE + "/logos/header.jpg",
};

export const META_TWITTER_BASE: Twitter = {
  ...TITLE_AND_DESCRIPTION,
  card: "summary_large_image",
  site: META_BRAND_NAME,
  creator: META_BRAND_NAME,
  images: WEB_URL_BASE + "/logos/header.jpg",
};

export const META_PAGE_BASE: Metadata = {
  ...TITLE_AND_DESCRIPTION,
  applicationName: META_BRAND_NAME,
  authors: [{ name: "Niche Digital Ventures Pty Ltd" }],
  openGraph: {
    ...META_OG_BASE,
  },
  twitter: {
    ...META_TWITTER_BASE,
  },
};
